module.exports = __webpack_public_path__ + "static/media/inbox-out.6b32cc55.svg";